import './NavMenu.scss';
import cls from 'classnames';
import React from 'react';
import { AppState } from 'core/redux/reducers';
// import { hot } from 'react-hot-loader/root'
import { connect } from 'react-redux';
import {
  INavMenu,
  makeSelectNavIsActive,
  makeSelectNavMenu,
  NavMenuTypes,
  NavTypes,
} from 'core/redux/features/shared/nav';
import { selectTranslator, TransFn } from 'core/redux/features/languages/trans';
import classNames from 'classnames';
import useLanguage from '../../useLanguage';
import ChangeLocaleBox from './ChangeLocaleBox';

function MenuItemsComp({
  items,
  label,
}: {
  items: INavMenu[];
  label?: string;
}) {
  return (
    <>
      {label ? <p className="menu-label-grey">{label}</p> : null}
      {items.map((item, index) => {
        const icon = item.settings?.icon;
        if (item.type === 'menu_item') {
          return (
            <a
              key={index}
              className={classNames(
                // icon && 'has-icon',
                'navbar-item navbar-item--desktop',
              )}
              href={item.link}
            >
              {icon ? (
                <span className="icon is-left eb eb-circle">
                  <span className={icon} />
                </span>
              ) : null}
              <span dangerouslySetInnerHTML={{ __html: item.title }} />
            </a>
          );
        }

        return (
          <p key={index} className="menu-label-grey">
            {item.title}
          </p>
        );
      })}

      <ChangeLocaleBox />

      <div className="mb-2" />
    </>
  );
}

interface IProps {
  mainMenus: INavMenu[];
  // socialMenus: INavMenu[]
  // localMenus: INavMenu[]
  trans: TransFn;
  show: boolean;
}

const MenuComp = (props: IProps) => {
  return (
    <>
      <MenuItemsComp items={props.mainMenus} />
      {/*<MenuItemsComp items={props.localMenus} label={props.trans('choose')} />*/}
      {/*<MenuItemsComp items={props.socialMenus} label="#EARLYBIRD" />*/}
    </>
  );
};

const mapStateToProps = (state: AppState) => {
  const selectNavMenu = makeSelectNavMenu();
  const selectNavIsActive = makeSelectNavIsActive();
  return {
    mainMenus: selectNavMenu(state, NavMenuTypes.main),
    // socialMenus: makeSelectNavMenu()(state, NavMenuTypes.social),
    // localMenus: selectNavMenu(state, NavMenuTypes.local),
    trans: selectTranslator(state),
    show: selectNavIsActive(state, NavTypes.Menu),
  };
};

const mapDispatchToProps = {};

// const DesktopNavMenuRoot =
//   process.env.NODE_ENV !== 'production' ? hot(MenuComp) : MenuComp;
const DesktopNavMenu = connect(mapStateToProps, mapDispatchToProps)(MenuComp);

export default DesktopNavMenu;
